import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon } from 'lucide-react';
const CERTIFICATE_IMAGE = 'https://cdn.magicpatterns.com/uploads/5WhatS69tSRoUFPDW2Uwmt/Gemini_Generated_Image_6gwufo6gwufo6gwu.png';
const FULL_PACK_IMAGE = 'https://cdn.magicpatterns.com/uploads/kWDjBZAB1iugGQSjKGiJrk/Diseno_sin_titulo_(23).png';
const MERCADO_PAGO_LOGO = 'https://cdn.magicpatterns.com/uploads/73T3L3nKMpYdtE5B56GqUG/mercadopago2.jpg';
const COMPRA_SEGURA_ICON = 'https://cdn.magicpatterns.com/uploads/rqvaYKxC7a7PP8rymJdSfm/safe-purchase-7779878_1280.png';
const GARANTIA_BADGE = 'https://cdn.magicpatterns.com/uploads/uH2wpvUcPj4Kb52ubF4uab/Selo-de-Garantia-de-7-Dias-PNG-Transparente-Sem-Fundo-1.png';
const MERCADO_LIDER_IMAGE = 'https://cdn.magicpatterns.com/uploads/w78hSqnaQQrLj1M1evZeGy/Gemini_Generated_Image_jbp7w2jbp7w2jbp7.png';
const BOBA_MASCOT = 'https://cdn.magicpatterns.com/uploads/dm8VbfVJkrkWH6bJRns5AR/Gemini_Generated_Image_p8ospmp8ospmp8os.png';
const neonCheckStyle = {
  textShadow: '0 0 8px #39FF14, 0 0 16px #39FF14'
};
export function PricingSection() {
  return <section id="pricing" className="relative" data-id="element-190">
      {/* Certificate Section - on cream bg */}
      <div className="bg-[#FDFBF7] pt-[1px] pb-[1px]" data-id="element-191">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-192">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-center justify-center gap-8" data-id="element-193">
            <h2 className="text-2xl md:text-3xl font-extrabold uppercase text-[#8B6914] font-sans" data-id="element-194">
              Además, obtienes un certificado a tu nombre
            </h2>

            <img src={CERTIFICATE_IMAGE} alt="Certificado Boba Professional" className="w-full max-w-lg mx-auto drop-shadow-xl rounded-lg bg-[#FDFBF7]" data-id="element-195" />

            <p className="text-gray-600 max-w-2xl mx-auto text-base md:text-lg leading-relaxed font-sans" data-id="element-196">
              Es un testimonio de tu amor por el arte de crear el bubble tea,
              combinando sabores y texturas de manera única. Este reconocimiento
              celebra no solo tu habilidad técnica, sino también el cariño que
              pones en cada taza que preparas.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Clean Wave transition from cream to green */}
      <div className="bg-[#FDFBF7] relative" data-id="element-197">
        <svg className="relative block w-full h-[80px] md:h-[120px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-198">
          <path d="M0,40 C300,100 600,0 900,60 C1050,90 1150,70 1200,40 L1200,120 L0,120 Z" fill="#2D5A27" data-id="element-199" />
        </svg>
      </div>

      {/* Main Green Pricing Section */}
      <div className="bg-[#2D5A27] pb-24 pt-8 relative overflow-hidden" data-id="element-200">
        {/* Decorative bg */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-201"></div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-202">
          {/* Bubble tea icon */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-203">
            <span className="text-5xl mb-6 block" data-id="element-204">🧋</span>

            <h2 className="text-3xl md:text-4xl font-extrabold font-sans uppercase text-white mb-6 leading-tight" data-id="element-205">
              ¡Elige esta{' '}
              <span className="text-[#D4A574]" data-id="element-206">NUEVA TENDENCIA</span> para ti!
            </h2>

            {/* Badge */}
            <div className="inline-block bg-[#D4A574] text-[#2D3728] font-bold px-6 py-2 rounded-full text-sm tracking-wider mb-10 uppercase" data-id="element-207">
              RECETAS PROBADAS Y LISTAS
            </div>
          </motion.div>

          {/* Full Pack Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="mb-10" data-id="element-208">
            <img src={FULL_PACK_IMAGE} alt="Pack Completo Boba Professional" className="w-full max-w-2xl mx-auto drop-shadow-2xl" data-id="element-209" />
          </motion.div>

          {/* Checklist */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-12" data-id="element-210">
            <ul className="space-y-4 inline-block text-left" data-id="element-211">
              <li className="flex items-start text-white" data-id="element-212">
                <span className="text-[#39FF14] mr-3 mt-0.5 text-lg font-bold" style={neonCheckStyle} data-id="element-213">
                  ✓
                </span>
                <span className="text-gray-100" data-id="element-214">
                  eBook: Boba Professional: El arte del Bubble Tea
                </span>
              </li>
              <li className="flex items-start text-white" data-id="element-215">
                <span className="text-[#39FF14] mr-3 mt-0.5 text-lg font-bold" style={neonCheckStyle} data-id="element-216">
                  ✓
                </span>
                <span className="text-gray-100" data-id="element-217">
                  Certificado de Finalización - Incluido
                </span>
              </li>
              <li className="flex items-start text-white" data-id="element-218">
                <span className="text-[#39FF14] mr-3 mt-0.5 text-lg font-bold" style={neonCheckStyle} data-id="element-219">
                  ✓
                </span>
                <span className="text-gray-100" data-id="element-220">
                  Los 9 Bonos Especiales - (Hoy Gratis)
                </span>
              </li>
              <li className="flex items-start text-white" data-id="element-221">
                <span className="text-[#39FF14] mr-3 mt-0.5 text-lg font-bold" style={neonCheckStyle} data-id="element-222">
                  ✓
                </span>
                <span className="text-gray-100" data-id="element-223">
                  Acceso inmediato por correo electrónico
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Unified Price & Security Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl max-w-lg mx-auto border border-gray-50" data-id="element-224">
            {/* Cuotas Badge */}
            <div className="mb-6 flex justify-center" data-id="element-225">
              <div className="shimmer-effect bg-[#2D5A27] text-white font-extrabold px-6 py-2 rounded-xl text-lg md:text-xl uppercase tracking-wider shadow-md border-2 border-[#D4A574]" data-id="element-226">
                HASTA 3 CUOTAS SIN INTERÉS
              </div>
            </div>

            {/* Price Section */}
            <div className="mb-6" data-id="element-227">
              <p className="text-gray-600 font-medium mb-2" data-id="element-228">
                Descarga tu eBook HOY con un
              </p>
              <div className="inline-block bg-red-100 text-red-600 font-bold px-5 py-2 rounded-xl text-xl" data-id="element-229">
                DESCUENTO DEL 60%
              </div>
              <p className="text-sm text-gray-500 mt-2" data-id="element-230">
                antes que acabe el día.
              </p>
            </div>

            <div className="mb-8 flex flex-col items-center" data-id="element-231">
              <p className="line-through text-2xl md:text-3xl mb-2 font-extrabold uppercase tracking-wide text-[#E75959]" data-id="element-232">
                ANTES: $59.900 ARS
              </p>
              <div className="flex flex-col items-center justify-center gap-1 mt-2" data-id="element-233">
                <span className="font-extrabold text-4xl md:text-5xl uppercase tracking-wider text-[#F04848]" data-id="element-234">
                  HOY:
                </span>
                <div className="bg-[#2D5A27] px-6 py-3 rounded-xl mt-2 flex items-baseline gap-2 shadow-lg" data-id="element-235">
                  <span className="text-5xl md:text-6xl font-extrabold text-white font-sans tracking-tight" data-id="element-236">
                    $19.990
                  </span>
                  <span className="text-white font-bold text-2xl" data-id="element-237">ARS</span>
                </div>
              </div>
              <p className="text-[#8B6914] mt-6 tracking-wide uppercase text-lg font-[700]" data-id="element-238">
                ¡ÚNICO PAGO SIN MENSUALIDADES!
              </p>
            </div>

            {/* CTA Button */}
            <motion.a href="https://checkout.bobaprofessional.shop/cart/45644497617094:1" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full bg-[#FFD700] hover:bg-[#FFE033] text-black text-lg md:text-xl font-extrabold py-5 px-8 rounded-2xl shadow-lg transition-colors flex items-center justify-center gap-2 group mb-8" data-id="element-239">
              CLIC AQUÍ PARA OBTENER LA OFERTA
              <span className="group-hover:translate-x-1 transition-transform" data-id="element-240">
                →
              </span>
            </motion.a>

            {/* Divider */}
            <div className="w-full h-px bg-gray-200 my-6" data-id="element-241"></div>

            {/* Security Section */}
            <div className="flex items-center justify-center gap-3 mb-5" data-id="element-242">
              <LockIcon className="w-6 h-6 text-[#1B3A5C]" data-id="element-243" />
              <h3 className="text-lg md:text-xl font-extrabold text-[#1B3A5C] uppercase text-center font-sans" data-id="element-244">
                MÉTODO DE PAGO SEGURO Y PROTEGIDO
              </h3>
            </div>

            <div className="bg-[#EEF4FB] rounded-xl p-4 mb-5 flex sm:flex-row gap-4 border border-[#D0E3F5] flex-row items-center justify-center" data-id="element-245">
              <img src={MERCADO_PAGO_LOGO} alt="Mercado Pago" className="max-h-12 object-contain" data-id="element-246" />
              <p className="text-[#009EE3] font-bold text-sm md:text-base uppercase text-center sm:text-left" data-id="element-247">
                TU COMPRA ESTÁ RESPALDADA POR MERCADO PAGO
              </p>
            </div>

            <p className="text-gray-600 text-center text-base md:text-lg leading-relaxed mb-5 font-sans font-medium" data-id="element-248">
              Tus datos están 100% encriptados y protegidos. Mercado Pago
              garantiza la seguridad total de tu transacción con tecnología de
              última generación.
            </p>

            <div className="flex items-center justify-center gap-3 mb-8 flex-wrap" data-id="element-249">
              <span className="inline-flex items-center px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-lg text-xs font-bold text-gray-600 uppercase" data-id="element-250">
                VISA
              </span>
              <span className="inline-flex items-center px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-lg text-xs font-bold text-gray-600 uppercase" data-id="element-251">
                MASTERCARD
              </span>
            </div>

            {/* MercadoLider Platinum Section */}
            <div className="mb-8 flex justify-center" data-id="element-252">
              <img src={MERCADO_LIDER_IMAGE} alt="MercadoLíder Platinum" className="w-full max-w-sm object-contain rounded-xl shadow-sm border border-gray-100" data-id="element-253" />
            </div>

            {/* Cute Mascot + Trust Message */}
            <div className="flex flex-col items-center mb-6" data-id="element-254">
              <img src={BOBA_MASCOT} alt="Boba Professional Mascot" className="w-16 h-16 rounded-full object-cover border-2 border-[#E8D5C4] shadow-md" data-id="element-255" />
              <p className="text-xs text-[#8B6914] uppercase tracking-wide mt-2 text-center font-[600] font-[Barlow,_sans-serif]" data-id="element-256">
                BOBA PROFESSIONAL: TU COMPRA ES SEGURA 🧋
              </p>
            </div>

            {/* Dark Trust Seals Row */}
            <div className="rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row items-center justify-center gap-8 md:gap-12 shadow-inner bg-[#04561D]" data-id="element-257">
              <div className="flex flex-col items-center gap-3" data-id="element-258">
                <img src={GARANTIA_BADGE} alt="Garantía 7 Días" className="max-h-24 md:max-h-28 object-contain drop-shadow-lg" data-id="element-259" />
                <span className="text-white font-bold text-sm md:text-base uppercase text-center tracking-wide" data-id="element-260">
                  GARANTÍA DE
                  <br data-id="element-261" />
                  SATISFACCIÓN
                </span>
              </div>
              <div className="flex flex-col items-center gap-3" data-id="element-262">
                <img src={COMPRA_SEGURA_ICON} alt="Compra Segura" className="max-h-24 md:max-h-28 object-contain drop-shadow-lg" data-id="element-263" />
                <span className="text-white font-bold text-sm md:text-base uppercase text-center tracking-wide" data-id="element-264">
                  COMPRA 100%
                  <br data-id="element-265" />
                  SEGURA
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}